import React from 'react';

import { Column, Row } from 'app/shopify/components/layout';

import { Date } from './Date';

export function DateShowcase() {
  return (
    <Column gap="spacing.general.x2" padding="spacing.general.x4">
      <Row gap="spacing.general.x2">
        <Date digit="2" />
        <Date digit="2" selected />
        <Date digit="2" selected state="conflict" />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" state="hover" />
        <Date digit="2" selected type="start" />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" state="pressed" />
        <Date digit="2" selected type="end" />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" state="disabled" />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" selected />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" selected type="middle" />
      </Row>

      <Row gap="spacing.general.x2">
        <Date digit="2" selected />
      </Row>
    </Column>
  );
}
